export default {
  profileId: (state) => {
    return state && state.profile && state.profile.id
  },
  userBucket: (state) => {
    return state && state.profile && `protected/${state.profile.userID}`
  }
}
